







































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import { fileLayoutTypes,fileLayoutModes } from '@/tenant/common';

@Component
export default class FileLayoutView extends Vue {
  public items: Common.FileLayout[] = new Array();
  public params: Common.FileLayoutQuery = new Common.FileLayoutQuery();

  public async onExec(item: any){
    // 伝票・明細で同一エイリアスが無いかのチェック
    if(item.headerFieldItems){
      let headerFieldItemNamesArray = (item.headerFieldItems as Array<Common.FieldItem>).map(obj=>obj.aliasName);
      let fieldItemNamesArray = (item.fieldItems as Array<Common.FieldItem>).map(obj=>obj.aliasName);
      let duplicateArray = new Array<string>();
      headerFieldItemNamesArray.forEach(obj => {if(obj != 'インポート番号' && fieldItemNamesArray.indexOf(obj) > -1)duplicateArray.push(obj);});
      if(duplicateArray.length > 0){
        // エイリアス名に重複がある場合警告を表示
        this.$api.modal.showDialog('',String.format('伝票フィールドと明細フィールドでエイリアス名({0})が重複しています。\r\n伝票フィールドの値のみがエクスポートされ、伝票・明細には同じ値がインポートされます。',duplicateArray.join('、'),true)).then(()=>{return false;});
      }
    }
  }
  //未設定
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'viewName', text: '表示画面' },
    { value: 'fileMode', text: '入出力区分' },
    { value: 'fileType', text: 'ファイルタイプ' },
    { value: 'layoutName', text: '設定名称' },
  ];

  public parents = {
    menu_sales_order_item: 'menu_sales_order',    
    menu_purchase_order_item: 'menu_purchase_order',    
    menu_sales_delivery_item: 'menu_sales_delivery',    
    menu_purchase_delivery_item: 'menu_purchase_delivery',    
    menu_invoice_item: 'menu_invoice',    
  };

  // public onWorkflow(index: number, obj: any) {
  //   this.$set(this.items, index, obj);
  // }

  public show(item: Common.AuditLog){
    var url = String.format(this.$api.formatter.formatByList(item.auditName,"auditSources"),item.auditNo);
    if (url){ this.$router.push(url);}
  }

  public onResetSystemTemplate() {
    this.$api.modal.showDialog('確認メッセージ','システムファイル設定を全て削除し、最新バージョンで初期化します。よろしいですか？',false).then(()=>{
      this.$api.execute(new Common.FileLayoutResetQuery()).then(res =>{
        var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
        this.$api.modal.show('処理結果','初期化処理が開始されました。\r\n実行結果は、以下のリンクから確認できます。',true,null,links);          
      });
    });
  }  

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }  
  public isCsv(item: Common.FileLayout): boolean{
    return item.fileType==fileLayoutTypes.csv||item.fileType==fileLayoutTypes.csvWithoutHeader;
  }
  public getFileLayoutType(item: Common.FileLayout): string{
    return item.fileMode==fileLayoutModes.export ? "fileLayoutTypes" : "importFileLayoutTypes";
  }
  public isImport(item: Common.FileLayout): boolean{
    return item.fileMode!=fileLayoutModes.export;
  }
  public onChangeFileLayoutMode(item: Common.FileLayout){
    if(item.fileMode!=fileLayoutModes.export && item.fileType!=fileLayoutTypes.excel) item.fileType=null;
  }
}
